import RideService from '../../services/RideService';
import EntryService from '../../services/EntryService';
import Position from '../../constants/Position';
import Statusses from '../../constants/Statusses';

export default {
  namespaced: true,
  state: {
    list: [],

    item: {},
  },
  mutations: {
    setList(state, rides) {
      state.list = rides;
    },
    addItem(state, ride) {
      state.item = {};

      state.item = ride;
    },
    clearItem(state) {
      state.item = {};
    },
    clear(state) {
      state.list = [];
      state.item = {};
    },
  },
  actions: {
    getRide({ commit }) {
      return new Promise((resolve, reject) => {
        RideService.getRide().then((ride) => {
          if (ride.id) {
            commit('addItem', ride);
            resolve();
          } else {
            resolve();
          }
        }).catch(reject);
      });
    },
    getRides({ commit }) {
      return new Promise((resolve, reject) => {
        RideService.getRides().then((rides) => {
          commit('setList', rides);
          resolve(rides);
        }).catch(reject);
      });
    },
    create({ dispatch }) {
      return new Promise((resolve, reject) => {
        RideService.create(Position.LATITUDE, Position.LONGITUDE).then((ride) => {
          dispatch('getRide').then(() => {
            resolve(ride);
          }).catch(reject);
        }).catch(reject);
      });
    },
    createEntry({ dispatch, commit }, { driveId, status }) {
      return new Promise((resolve, reject) => {
        EntryService.create(
          driveId,
          status,
          Position.LATITUDE,
          Position.LONGITUDE,
        ).then(() => {
          if (status !== Statusses.STOP) {
            dispatch('getRide').then(() => {
              resolve();
            }).catch(reject);
          } else {
            dispatch('getRides').then(() => {
              commit('clearItem');
              resolve();
            }).catch(reject);
          }
        }).catch(reject);
      });
    },
  },
};
